import React from "react";
import {
  SettingsFormGroup, SettingsFormLabel, SettingsFormSelect, SettingsFormGrid,
} from "../../Settings/SettingShell";

/**
 * Shared FY / location / sub-location fields, used by both the single-file
 * upload modal and the batch-upload modal. Tags are no longer a free-form
 * field here — tag-based organization now flows entirely through KPI
 * selection (TagFilterBar over the reporting-questions map), the same
 * everywhere evidence is uploaded or filtered.
 *
 * `showLocation` hides source/sub-location when questionType is qualitative
 * (tabular_question), per the business rule that qualitative evidence
 * forbids sourceId/subLocationId.
 */
const EvidenceFormFields = ({
  financialYears = [],
  financialYearId,
  onFinancialYearChange,
  sources = [],
  sourceId,
  onSourceChange,
  subLocationId,
  onSubLocationChange,
  showLocation = true,
}) => {
  const selectedSource = sources.find((s) => String(s.id) === String(sourceId));
  const subLocations = selectedSource?.subLocation || [];

  return (
    <>
      <SettingsFormGrid>
        <SettingsFormGroup>
          <SettingsFormLabel>Financial Year *</SettingsFormLabel>
          <SettingsFormSelect
            value={financialYearId ?? ""}
            onChange={(e) => onFinancialYearChange(e.target.value)}
          >
            <option value="">Select Financial Year</option>
            {financialYears.map((fy) => (
              <option key={fy.id} value={fy.id}>{fy.financial_year_value}</option>
            ))}
          </SettingsFormSelect>
        </SettingsFormGroup>

        {showLocation && (
          <SettingsFormGroup>
            <SettingsFormLabel>Location *</SettingsFormLabel>
            <SettingsFormSelect
              value={sourceId ?? ""}
              onChange={(e) => { onSourceChange(e.target.value); onSubLocationChange(""); }}
            >
              <option value="">Select Location</option>
              {sources.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.unitCode ? s.unitCode : `${s.location?.city} - ${s.location?.state}`}
                </option>
              ))}
            </SettingsFormSelect>
          </SettingsFormGroup>
        )}
      </SettingsFormGrid>

      {showLocation && (
        <SettingsFormGroup style={{ marginTop: 12 }}>
          <SettingsFormLabel>Sub-location</SettingsFormLabel>
          <SettingsFormSelect
            value={subLocationId ?? ""}
            onChange={(e) => onSubLocationChange(e.target.value)}
            disabled={!subLocations.length}
          >
            <option value="">{subLocations.length ? "Select Sub-location" : "No sub-locations"}</option>
            {subLocations.map((sub) => (
              <option key={sub.id} value={sub.id}>{sub.subLocation}</option>
            ))}
          </SettingsFormSelect>
        </SettingsFormGroup>
      )}
    </>
  );
};

export default EvidenceFormFields;
